<app-modal
  [open]="open"
  [title]="title"
  [message]="periodLabel"
  primaryText="Fechar"
  (close)="requestClose()"
  (primary)="requestClose()"
>
  <section class="connectivity-content">
    <div class="connectivity-toolbar">
      <label>
        <span>Período</span>
        <select [value]="preset" (change)="selectPreset($any($event.target).value)">
          <option value="24h">Últimas 24 horas</option>
          <option value="7d">Últimos 7 dias</option>
          <option value="30d">Últimos 30 dias</option>
          <option value="custom">Personalizado</option>
        </select>
      </label>

      <div class="custom-range" *ngIf="preset === 'custom'">
        <label><span>Início</span><input type="datetime-local" [value]="customStart" (change)="customStart = $any($event.target).value" /></label>
        <label><span>Fim</span><input type="datetime-local" [value]="customEnd" (change)="customEnd = $any($event.target).value" /></label>
        <button type="button" class="refresh-btn" (click)="applyCustomRange()">Atualizar</button>
      </div>
    </div>

    <div class="uptime-card">
      <span>Uptime no período</span>
      <strong>{{ uptimeLabel }}</strong>
      <small *ngIf="data?.uptime_percent === null">Sem histórico anterior suficiente para calcular.</small>
      <small *ngIf="data?.uptime_percent !== null && data">{{ formatDuration(data.total_ms - data.offline_ms) }} on-line de {{ formatDuration(data.total_ms) }}</small>
    </div>

    <p class="error" *ngIf="errorMessage">{{ errorMessage }}</p>
    <p class="loading" *ngIf="loading">Carregando conectividade...</p>

    <div class="table-scroll" *ngIf="!loading && data">
      <table class="connectivity-table" aria-label="Desconexões do gateway">
        <thead>
          <tr>
            <th>Desconectou em</th>
            <th>Reconectou em</th>
            <th>Tempo offline</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngIf="!data.outages.length">
            <td colspan="3" class="empty">Nenhuma desconexão no período selecionado.</td>
          </tr>
          <tr *ngFor="let outage of pagedOutages">
            <td>{{ formatTimestamp(outage.disconnected_at) }}</td>
            <td>{{ formatReconnect(outage.reconnected_at) }}</td>
            <td>{{ formatDuration(outage.offline_ms) }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <footer class="table-footer" *ngIf="!loading && data && data.outages.length">
      <span>{{ data.outages.length }} desconex{{ data.outages.length === 1 ? 'ão' : 'ões' }}</span>
      <div class="pager-controls">
        <label><span>Por página</span><select [value]="pageSize" (change)="setPageSize($any($event.target).value)"><option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option></select></label>
        <button type="button" (click)="prevPage()" [disabled]="pageIndex === 0">‹</button>
        <span>{{ pageIndex + 1 }} / {{ pageCount }}</span>
        <button type="button" (click)="nextPage()" [disabled]="pageIndex + 1 >= pageCount">›</button>
      </div>
    </footer>
  </section>
</app-modal>
